import createFormReducer, {getFormInitialState} from "../../../../../../redux/actions-reducers/form/create-form-reducer"

const validCard = require('card-validator')

export const FORM_CARD_INFO_NAME = 'formCardInfo'

const initialState = {
    ...getFormInitialState(),
    valid:false ,
    values: {
        holderName:'',
        number: '',
        validThru: '',
        cvc: '',
    }
}


export function validate({
                             holderName = '',
                             number = '',
                             validThru = '',
                             cvc = '',
                         }) {

    const errorMessages = {}

    if (!validateCardNumber(number))
        errorMessages.number = ['Número inválido.']


    if (!validateValidThru(validThru))
        errorMessages.validThru = ['Data de vencimento inválida.']


    if (!validateHolderName(holderName))
        errorMessages.holderName = ['Nome inválido.']

    if (!validateCVC(cvc))
        errorMessages.cvc = ['CVC inválido.']

    return errorMessages
}


export function validateCardNumber(number = '') {
    return validCard.number(number).isValid
}


export function validateValidThru(validThru = '') {
    if (validThru.indexOf('/') < 0 )
        return false
    const [month, year] = validThru.split('/')

    return validateMonth(month) && validateYear(year)
}



export function validateMonth(month = '') {
    if (month.length !== 2)
        return false

    if (month.replace(/([^0-9])+/i, "").length !== 2)
        return false


    const intMonth = parseInt(month, 10) || -1

    if (intMonth < 1 || intMonth > 12)
        return false

    return true
}


export function validateYear(year = '') {
    if (year.length !== 2)
        return false
    const intYear = parseInt(year.replace(/([^0-9])+/i, ""), 10) || -1
    const actualYear = parseInt(new Date().getFullYear().toString().substr(-2) + '', 10)

    if (intYear < actualYear)
        return false

    return true
}


export function validateHolderName(name = '') {

    if (name.length < 2 )
        return false

    if ( ! /^[a-zA-Z ]+$/.test(name))
        return false

    if (name.indexOf(' ') < 0)
        return false

    return true

}


export function validateCVC(cvc = '') {

    if (cvc.replace(/([^0-9])+/i, "").length !== 3 )
        return false

    return true
}



export const formCardInfoReducer = createFormReducer(FORM_CARD_INFO_NAME, validate, initialState)


// WEBPACK FOOTER //
// ./src/_pages/Sale/_partials/PaymentStep/_components/FormCardInfo/reducer.js